class StickyHeader extends HTMLElement {
	constructor() {
		super()

		document.addEventListener("DOMContentLoaded", this.init.bind(this))
	}

	connectedCallback() {
		this.transparentClass = 'header--transparent'
		this.stickyClass = 'shopify-section-header-sticky'
		this.parent = this.parentElement
	}

	init() {
		let firstSection = document.querySelector("main .shop-the-look-section:first-of-type")
		if(firstSection?.classList.contains('overlay-header')) {
			this.classList.add("header--transparent", "is-transparent")
		}

		this.isTransparent = this.classList.contains('is-transparent')

		window.addEventListener("scroll", this.onScroll.bind(this))
		window.addEventListener("resize", this.onScroll.bind(this))
		// this.addEventListener("mouseenter", this.onMouseenter.bind(this))
		// this.addEventListener("mouseleave", this.onMouseleave.bind(this))

		window.addEventListener("searchOpen", this.onSearchOpen.bind(this))
		window.addEventListener("searchClose", this.onSearchClose.bind(this))
		window.addEventListener("modalOpen", this.onModalOpen.bind(this))
		window.addEventListener("modalClose", this.onModalClose.bind(this))

		this.querySelectorAll('burger-menu, header .list-menu-item')?.forEach(menu => {
			menu.addEventListener("mouseenter", this.onMouseenter.bind(this))
			menu.addEventListener("mouseleave", this.onMouseleave.bind(this))
		})

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				document.documentElement.style.setProperty('--header-height', `${this.clientHeight}px`)
			})
		})
		this.setHeaderHeightProp()

		window.addEventListener('load', () => {
			requestAnimationFrame(() => {
				if (this.isInTop()) {
					document.documentElement.style.setProperty('--header-height', `${this.clientHeight}px`)
				}
			})
		})
	}

	onScroll() {
		if(this.isInTop()) {
			this.parent.classList.remove('header--on-scroll')
		}else {
			this.parent.classList.add('header--on-scroll')
		}

		if(this.isInTop() && !this.classList.contains(this.transparentClass) && this.isTransparent) {
			this.classList.add(this.transparentClass)
		}

		if(this.isInTop()) {
			if(this.parent.classList.contains(this.stickyClass)) {
				this.parent.classList.remove(this.stickyClass)
				this.setHeaderHeightProp()
			}

		}else {
			if(this.isTransparent) this.classList.remove('header--transparent')
			if(!this.parent.classList.contains(this.stickyClass)) {
				this.parent.classList.add(this.stickyClass)
				this.setHeaderHeightProp()
			}

			if(window.scrollY > this.previousScroll) {
				this.parent.classList.add(`${this.stickyClass}--hidden`)
			}else {
				this.parent.classList.remove(`${this.stickyClass}--hidden`)
			}
		}

		this.previousScroll = window.scrollY
	}

	setHeaderHeightProp() {
		document.documentElement.style.setProperty('--variable-header-height', `${this.clientHeight}px`)

		if (this.isInTop()) {
			document.documentElement.style.setProperty('--header-height', `${this.clientHeight}px`)
			document.documentElement.style.setProperty('--announcement-bar-height', `${document.querySelector('.shopify-section.shopify-section-group-header-group.section-announcement')?.clientHeight || 0}px`)
		} else {
			document.documentElement.style.setProperty('--announcement-bar-height', `0px`)
		}
	}

	onMouseenter() {
		if(this.isTransparent) this.classList.remove('header--transparent')
	}

	onMouseleave() {
		if(this.isInTop() && !document.body.classList.contains('overflow-hidden') && !document.body.classList.contains('overflow-hidden-tablet')) {
			if(this.isTransparent) this.classList.add('header--transparent')
		}
	}

	onSearchOpen() {
		this.parent.classList.remove(this.stickyClass)
		this.parent.classList.add(`${this.stickyClass}--full`)
		this.setHeaderHeightProp()
		this.onMouseenter()
	}

	onSearchClose() {
		this.parent.classList.remove(`${this.stickyClass}--full`)
		if(!this.isInTop()) this.parent.classList.add(this.stickyClass)
		this.setHeaderHeightProp()
		this.onMouseleave()
	}

	onModalOpen() {
		if(this.isInTop()) window.scrollTo({top: 0})

		setTimeout(() => {
			this.parent.classList.remove(this.stickyClass)
			this.parent.classList.add(`${this.stickyClass}--full`)
			this.setHeaderHeightProp()
			this.onMouseenter()
		}, 50)
	}

	onModalClose() {
		this.parent.classList.remove(`${this.stickyClass}--full`)
		if(!this.isInTop()) this.parent.classList.add(this.stickyClass)
		this.setHeaderHeightProp()
		this.onMouseleave()
	}

	isInTop() {
		return window.scrollY < this.clientHeight + 40
	}
}
customElements.define('sticky-header', StickyHeader)